<sk-modal-content
  [title]="'label.versionMismatchModalTitle' | translate"
  [isHideCross]="true"
  [isHideCloseBtn]="true">
  <ng-container id="sk-modal-body">
    {{"message.VersionMismatchModalContent" | translate }}
  </ng-container>
  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Logout' | translate"
      (click)="logoutAndRefresh()"
      data-test="logout-footer-button">
    </sk-button>
    <sk-button
      [color]="'primary'"
      [appearance]="'link'"
      [label]="'label.Continue' | translate"
      (click)="continueNavigation()"
      data-test="continue-footer-button">
    </sk-button>
  </ng-container>
</sk-modal-content>
